// extracted by mini-css-extract-plugin
export default {"slideContainer":"f0dad03714 _0f5ab39f8c f4be798a59","slideImage":"_874c982abb"};